module.exports = __webpack_public_path__ + "static/media/icon_help.fdad973f.svg";